import { GuardedComponent } from '../components/guarded-component';
import { BillingReportPage } from '../features/billing-report/billing-report.page';
import { UserPermissionName } from '../models/user-permission-name';

export const BillingReportRoute = {
  path: '/billing-reports',
  name: 'Billing Reports',
  children: [
    {
      index: true,
      element: (
        // <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_INVOICE_REPORTS]} showPermissionError>
          <BillingReportPage />
        // </GuardedComponent>
      ),
    },
  ],
};
